import { useContext } from "react";
import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";
import {
  setCentroId,
  wsGetCentros,
} from "_+_Portal/_-_Autocheckin/context/action/atencionSinTurno";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { Geolocation } from "@capacitor/geolocation";
import {
  EstaEnDim,
  getItemWithExpiry,
  listarCentros,
  setItemWithExpiry,
} from "../PagesFun";

const UbicacionSinTurno = ({ setLoading, setError }) => {
  // -------------------------  context ----------------------------
  const { pasoDispatch, atencionSinTurnoDispatch } =
    useContext(AutocheckContext);
  // -------------------------  context ----------------------------

  // -------------------------  funciones ----------------------------
  const handleClickOne = () => {
    const ubicacionGuardada = getItemWithExpiry("ubicacion");
    if (!ubicacionGuardada) {
      let nextStep = (isCorrect, centros) => {
        const centrosListados = listarCentros(centros);
        if (isCorrect) {
          Geolocation.getCurrentPosition()
            .then((resp) => {
              let latitud = resp.coords.latitude; // resp.coords.latitude;
              let longitud = resp.coords.longitude; // resp.coords.longitude;
              let location = EstaEnDim(latitud, longitud, centrosListados);
              setItemWithExpiry("ubicacion", location);
              setCentroId([location])(atencionSinTurnoDispatch);
              if (location.length > 1) {
                setPaso("PreguntarCentro")(pasoDispatch);
              }
              if (location && !(location.length > 1)) {
                setPaso("AtencioSinTurno")(pasoDispatch);
              } else if (!location) {
                throw new Error();
              }
            })
            .catch((err) => {
              setError({
                message: "No se ha podido detectar su ubicación",
                errorBack: "Home",
              });
              setPaso("ModalErrorAutoT")(pasoDispatch);
            });
        }
      };
      setLoading("Cargando...");
      wsGetCentros(nextStep)(atencionSinTurnoDispatch);
    } else {
      setCentroId([ubicacionGuardada])(atencionSinTurnoDispatch);
      if (ubicacionGuardada.length > 1) {
        setPaso("PreguntarCentro")(pasoDispatch);
      }
      if (ubicacionGuardada && !(ubicacionGuardada.length > 1)) {
        setPaso("AtencioSinTurno")(pasoDispatch);
      }
    }
  };

  const handleClickTwo = () => {
    setPaso("Home")(pasoDispatch);
  };

  // -------------------------  funciones ----------------------------

  return (
    <ModalAutoT
      title={`¿Usted se encuentra en DIM? `}
      desc={`
      Le solicitamos está información para que usted pueda realizar los siguientes tramites
  `}
      textBtnOne={"SI"}
      textBtnTwo={"NO"}
      handleChange={{ btnOne: handleClickOne, btnTwo: handleClickTwo }}
    />
  );
};

export default UbicacionSinTurno;
